import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { listCharterPromotion, upsertCharterPromotion } from '~/services/CharterPromotionService';

import type {
  ListCharterPromotionPricingInventoryParams,
  UpsertCharterPromotionPricingInventoryBody,
} from '~/types/charterPromotionPricingInventory';

import { charterPromotionQueryKeys } from './charterPromotionQueryKeys';

export function useGetCharterPromotionList(
  params: ListCharterPromotionPricingInventoryParams = {},
  options: { enabled?: boolean } = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: charterPromotionQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      const { promotionType = 'HUNDRED_DOLLAR', ...filters } = params;
      return await listCharterPromotion(promotionType, filters, { signal });
    },
    enabled,
  });
}

export function useUpsertCharterPromotion(promotionType = 'HUNDRED_DOLLAR') {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpsertCharterPromotionPricingInventoryBody) => {
      return await upsertCharterPromotion(promotionType, body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterPromotionQueryKeys.all });
    },
  });
}
